export default __webpack_public_path__ + "asset/img/icon-views~19dfe683.png";